import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../Context/AppContext";
import LinearProgressBar from "../../../Components/LinearProgressBar";
import { setupCardStyles as s } from "../styles/styles";

// Uses the REAL "Get Started" data already loaded in AppContext
// (getStartedContent) — the same source as the sidebar's Get Started popover.
// No mock, no backend work. Hides itself at 100%. Role-aware: the CM dashboard
// shows the community tasks; the supplier dashboard shows the supplier tasks.
const ADMIN_TASKS = [
  {
    key: "communityShine",
    field: "communityShineCompleted",
    statement: "communityTasks.communityShine",
    route: "/community-settings",
  },
  {
    key: "supplierCount",
    field: "supplierCount",
    statement: "communityTasks.supplierCount",
    route: "/my-suppliers",
  },
];

const SUPPLIER_TASKS = [
  {
    key: "businessStandout",
    field: "businessStandoutCompleted",
    statement: "supplierTasks.businessStandout",
    route: "/business-settings",
  },
  {
    key: "paymentMethodsSetup",
    field: "paymentMethodsSetup",
    statement: "supplierTasks.paymentMethodsSetup",
    route: "/business-settings",
  },
  {
    key: "pricedService",
    field: "pricedService",
    statement: "supplierTasks.pricedService",
    route: "/manage-pricelists",
  },
  {
    key: "joinedCommunity",
    field: "joinedCommunity",
    statement: "supplierTasks.joinedCommunity",
    route: "/my-communities",
  },
];

const SetupCard = () => {
  const { t } = useTranslation("page-dashboard");
  const { t: tb } = useTranslation("bottom-menu-and-settings");
  const { getStartedContent } = useContext(AppContext);

  const isCommunityManagementRole =
    localStorage.getItem("isCommunityManagementRole") === "true";

  const source = isCommunityManagementRole
    ? getStartedContent?.getStartedTasks
    : getStartedContent?.supplierTasks;
  const taskDefs = isCommunityManagementRole ? ADMIN_TASKS : SUPPLIER_TASKS;
  const title = isCommunityManagementRole
    ? t("setup.title")
    : t("setup.title_supplier");

  const percentage = source?.percentageComplete;

  if (percentage == null || percentage >= 100) return null;

  const tasks = taskDefs
    .map((task) => {
      const raw = source[task.field];
      const done = typeof raw === "object" ? !!raw?.completed : !!raw;
      return { ...task, done };
    })
    .sort((a, b) => (b.done ? 1 : 0) - (a.done ? 1 : 0));

  const anyDone = tasks.some((task) => task.done);

  return (
    <Box sx={s.card}>
      <Typography sx={s.title}>{title}</Typography>

      <Box sx={s.progressWrap}>
        <LinearProgressBar percentage={percentage} showPercentageText={true} />
      </Box>

      <Box sx={s.tasks}>
        {tasks.map((task) => (
          <Box key={task.key} sx={s.taskRow}>
            {task.done ? (
              <img src="/icons/check-icon.svg" alt="" width={10} />
            ) : anyDone ? (
              <Box sx={{ width: "10px" }} />
            ) : null}
            <Typography
              component={!task.done && task.route ? NavLink : "span"}
              to={!task.done && task.route ? task.route : undefined}
              sx={task.done ? s.taskDone : s.taskTodo}
            >
              {tb(task.statement)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SetupCard;
